import React, { useEffect } from 'react';
import { LogOut, ArrowRight, Heart } from 'lucide-react';
import { RESET_ALL_DATA } from '../../../redux/actions/types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';

const RecruiterProfileMenu = ({ isOpen, onClose, onLogin }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const recruiterAccessToken = useSelector((store) => store?.hallOfFame?.recruiterAccessToken);

    const handleSignOut = () => {
        if (recruiterAccessToken) {
            dispatch({ type: RESET_ALL_DATA });
            navigate('/recruiter');
            onClose();
        } else {
            onLogin();
            onClose();
        }
    };

    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (event) => {
            // Try to find the menu DOM node
            const menu = document.getElementById('recruiter-profile-menu');
            if (menu && !menu.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div id="recruiter-profile-menu" className={`fixed md:absolute top-16 md:top-full right-4 md:right-0 md:mt-2 z-50 w-[160px] border border-gray-800/50 rounded-2xl p-2 shadow-2xl ${isOpen ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full md:translate-x-0 md:translate-y-0 pointer-events-none"} ${!isOpen && "md:hidden"} transition-all duration-300`} style={{ backgroundImage: "linear-gradient(180deg, #0B2435 0%, #0E3653 100%)" }}>
            <div className="flex flex-col gap-1">
                {/* Shortlist Item */}
                <button className="flex items-center justify-between w-full p-3.5 rounded-xl hover:bg-white/5 transition-all group" onClick={() => {
                    if (recruiterAccessToken) {
                        Mixpanel.track(Constants.Mixpanel.RECRUITER_SHORTLIST_PAGE_CLICKED);
                        navigate('/recruiter/profile');
                        onClose();
                    } else {
                        onLogin();
                        onClose();
                    }
                }}>
                    <div className="flex items-center gap-3">
                        <Heart className="w-5 h-5 text-[#406AFF]" />
                        <span className="text-white font-medium text-sm">Shortlist</span>
                    </div>
                    <ArrowRight className="w-5 h-5 text-white transition-colors" />
                </button>

                {/* Sign Out Item */}
                <button onClick={handleSignOut} className="flex items-center gap-3 w-full p-3.5 rounded-xl hover:bg-white/5 transition-all group">
                    <LogOut className="w-5 h-5 text-[#406AFF]" />
                    <span className="text-white font-medium text-sm">{recruiterAccessToken ? "Sign Out" : "Login"}</span>
                </button>
            </div>
        </div>
    );
};

export default RecruiterProfileMenu;
